document.addEventListener('DOMContentLoaded', () => {
  const countdownSettingsJson = document.querySelector('[data-countdown-timer-settings-json]');
  if (!countdownSettingsJson) return;

  const countdownSettings = JSON.parse(countdownSettingsJson.textContent);

  const endDateSetting = countdownSettings.endDate;
  const resetTimer = countdownSettings.resetTimer;

  const [year, month, day] = endDateSetting.split('-').map(Number);
  let endDate = new Date(year, month - 1, day, 23, 59, 59);

  // If resetTimer is true, set endDate to 23:59:59 of current day
  if (resetTimer) {
    const now = new Date();
    // Set to end of current day (23:59:59)
    endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);

    // Store the reset date (just the date, not time) in localStorage
    const storedResetDate = localStorage.getItem('countdownResetDate');
    const todayDate = now.toDateString();

    if (storedResetDate !== todayDate) {
      // It's a new day, reset to today's 23:59:59
      endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      localStorage.setItem('countdownResetDate', todayDate);
    }
  }

  function updateCountdown() {
    const now = new Date();
    const timeLeft = endDate - now;

    if (timeLeft <= 0) {
      if (resetTimer) {
        // Reset to next day's 23:59:59
        const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 23, 59, 59);
        endDate = tomorrow;
        localStorage.setItem('countdownResetDate', now.toDateString());
      } else {
        document.querySelectorAll('.top-bar-alt').forEach((el) => el.classList.add('hidden'));
        return;
      }
    }

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
    const daysLabel = days === 1 ? 'dan' : 'dana';

    const pad = (n) => n.toString().padStart(2, '0');

    document.querySelectorAll('#countdown-days').forEach((el) => (el.textContent = pad(days)));
    document.querySelectorAll('#countdown-hours').forEach((el) => (el.textContent = pad(hours)));
    document.querySelectorAll('#countdown-minutes').forEach((el) => (el.textContent = pad(minutes)));
    document.querySelectorAll('#countdown-seconds').forEach((el) => (el.textContent = pad(seconds)));
    document.querySelectorAll('.countdown-days-clone').forEach((el) => (el.textContent = pad(days)));
    document.querySelectorAll('.countdown-hours-clone').forEach((el) => (el.textContent = pad(hours)));
    document.querySelectorAll('.countdown-minutes-clone').forEach((el) => (el.textContent = pad(minutes)));
    document.querySelectorAll('.countdown-seconds-clone').forEach((el) => (el.textContent = pad(seconds)));
    document.querySelectorAll('.js-label-days').forEach((el) => (el.textContent = daysLabel));
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
});

/*
  # - Product Discount percentage
*/
if (!customElements.get('product-discount')) {
  customElements.define(
    'product-discount',
    class ProductDiscount extends HTMLElement {
      constructor(...args) {
        super(...args);

        this.selectors = {
          discount: '.js-product-discount',
          productJSON: '.js-product-template',
          mainSelect: '.single-option-selector',
        };

        this.classes = {
          isHidden: 'is-hidden',
        };

        this.discount = $(this.selectors.discount);
        this.discountText = this.discount.find('span');
        this.percentage;
        this.productJSONElement = $(this.selectors.productJSON);

        if (!this.productJSONElement.length) return;

        this.productJSON = JSON.parse($(this.productJSONElement).html());
        this.variants = this.productJSON.variants;

        setTimeout(() => {
          this.mainSelect = $(this.selectors.mainSelect);
          this.init();
        }, 200);
      }

      init() {
        this.mainSelect.on('change', () => {
          if (!this.mainSelect) return;

          const value = this.mainSelect.val();

          for (let i = this.variants.length - 1; i >= 0; i--) {
            const variant = this.variants[i];

            if (variant.title == value) {
              const price = +variant.price;
              const compareAtPrice = +variant.compare_at_price;

              if (compareAtPrice < price) {
                this.percentage = null;
                this.hide();

                return;
              }

              this.recalcPercentage(price, compareAtPrice);
              this.show();

              break;
            }
          }
        });
      }

      hide() {
        this.discount.addClass(this.classes.isHidden);
        this.discountText.text('');
      }

      show() {
        this.discountText.text(`-${this.percentage}%`);
        this.discount.removeClass(this.classes.isHidden);
      }

      recalcPercentage(price, compareAtPrice) {
        this.percentage = Math.floor(((compareAtPrice - price) * 100) / compareAtPrice);
      }
    }
  );
}

// const initWishlistWidgets = () => {
//   /*
//    # - Add Wishlist to Header
//   */
//   WishlistKing.observe(
//     {
//       // Adjust the selector target your cart link
//       selector: '.js-header-wishlist',
//     },
//     (target) => {
//       target.append(WishlistKing.createComponent('wishlist-link'));
//     }
//   );

//   /*
//    # - Add Wishlist to PDP
//   */
//   const productId = document.querySelector('.js-product-section [data-product-id]')?.dataset.productId;

//   WishlistKing.observe(
//     {
//       // Adjust the selector to target a element
//       selector: '.js-product-section .product-block--price',
//       // Only run on product pages
//       template: 'product',
//     },
//     (target) => {
//       target.append(
//         WishlistKing.createComponent('wishlist-button', {
//           // Set product id with liquid
//           id: productId,
//         })
//       );
//     }
//   );

//   /*
//    # - Add Wishlist Page
//   */
//   WishlistKing.observe(
//     {
//       // Adjust the selector to target a element
//       selector: '.js-wishlist-page',
//       // Only run on pages
//       template: 'page',
//       // Use wishlist page handle from app settings
//       handle: WishlistKing.toolkit.settings.wishlistPageHandle,
//     },
//     (target) => {
//       target.insertAfter(WishlistKing.createComponent('wishlist-page'));
//     }
//   );

//   /*
//    # - Add Wishlist Shared Page
//   */
//   WishlistKing.observe(
//     {
//       selector: '.js-wishlist-shared-page',
//       template: 'page',
//       // Make sure to use the sharedWishlistPageHandle handle
//       handle: WishlistKing.toolkit.settings.sharedWishlistPageHandle,
//     },
//     (target) => {
//       target.insertAfter(WishlistKing.createComponent('wishlist-page-shared'));
//     }
//   );
// };

/*
 # - Update Cart Counter
*/
const updateCartCounter = (number) => {
  const cartCounters = document.querySelectorAll('.js-cart-counter');
  const isHidden = 'is-hidden';

  cartCounters.forEach((counter) => {
    counter.textContent = number;
    counter.classList.toggle(isHidden, number == 0);
  });
};

/*
 # - This functionality is attached to the product badge that askes you to login/register.
 #   After a succcessful login/register it redirects you to the product page
*/
const redirectToProductAfterLogin = () => {
  const linkClass = '.js-register-discount-badge';
  const productUrlKey = 'badge-product-url';
  const isAccountDashboardPage = document.body.classList.contains('customers-account');

  const addProductToSessionStorage = (link) => {
    const productUrl = link.dataset.productUrl;

    sessionStorage.setItem(productUrlKey, productUrl);
  };

  document.addEventListener('click', (event) => {
    const badgeLink = event.target.closest(linkClass);

    if (badgeLink) {
      addProductToSessionStorage(badgeLink);
    }
  });

  // Abort if the page is not Account dashboard
  if (!isAccountDashboardPage) {
    return;
  }

  // Redirect to the product page if there is product info in the session.
  const spinner = document.querySelector('.js-spinner');
  const data = sessionStorage.getItem(productUrlKey);

  if (!data) {
    return;
  }

  spinner?.classList.add('is-visible');
  sessionStorage.removeItem(productUrlKey);
  window.location = window.location.origin + data;
};

redirectToProductAfterLogin();

/*
 # - Rebuy On Cart Change
*/
document.addEventListener('theme:add-to-cart', (event) => {
  const cart = event.detail.cart;
  updateCartCounter(cart.item_count);
});

document.addEventListener('theme:update-cart', (event) => {
  const cart = event.detail.cart;
  updateCartCounter(cart.item_count);
});

/*
 # - Collection Description Read More/Less
*/

$('[data-read-more]').on('click', function (e) {
  e.preventDefault();
  const $this = $(this);
  const $container = $this.closest('[data-read-more-container]');
  const $shortDescription = $container.find('[data-short-description]');
  const $fullDescription = $container.find('[data-full-description]');
  const $readLess = $container.find('[data-read-less]');

  $shortDescription.hide();
  $fullDescription.show();
  $readLess.show();
  $this.hide();
});

$('[data-read-less]').on('click', function (e) {
  e.preventDefault();
  const $this = $(this);
  const $container = $this.closest('[data-read-more-container]');
  const $shortDescription = $container.find('[data-short-description]');
  const $fullDescription = $container.find('[data-full-description]');
  const $readMore = $container.find('[data-read-more]');

  $shortDescription.show();
  $fullDescription.hide();
  $this.hide();
  $readMore.show();
});

$(document).ready(function () {
  const mediaQuery = '(max-width: 798px)';
  const mediaQueryList = window.matchMedia(mediaQuery);
  const headerHeight = $('#header').outerHeight();
  const main = $('.section-wrapper');

  if (window.innerWidth < 798) {
    main.css('margin-top', headerHeight);
  }

  mediaQueryList.addEventListener('change', (event) => {
    if (event.matches) {
      main.css('margin-top', headerHeight);
    } else {
      main.css('margin-top', 0);
    }
  });
});
